import React, { useEffect, useState } from "react";

import ThSarabun from "../../fonts/THSarabunNew.ttf";
import ThSarabunBold from "../../fonts/THSarabunNew-Bold.ttf";
import ThSarabunItalic from "../../fonts/THSarabunNew-Italic.ttf";
import ThSarabunBoldItalic from "../../fonts/THSarabunNew-BoldItalic.ttf";
import PromptRegular from "../../fonts/prompt/Prompt-Regular.ttf";
import Browallia from "../../fonts/browallia/BrowalliaUPC2.ttf";

import {
  Document,
  Font,
  Page,
  View,
  Text,
  Image,
  Line,
} from "@react-pdf/renderer";

import {
  getCommalessNumber,
  getDecimalString,
  GetPatientAge,
  GetPatientSex,
  GetThaiBahtString,
} from "../../core/Helper2";
import {
  GetCenterTextView,
  GetVerySmallTextView,
  BillStylesA4 as styles,
} from "./BillStyle";
import { GetThaiFormatDate, MysqlDateCV } from "../../core/Helper";

export const RegisterFont = () => {
  Font.register({ family: "ThSarabun", src: ThSarabun });
  Font.register({ family: "ThSarabunBold", src: ThSarabunBold });
  Font.register({ family: "ThSarabunItalic", src: ThSarabunItalic });
  Font.register({ family: "ThSarabunBoldItalic", src: ThSarabunBoldItalic });
  Font.register({ family: "PromptRegular", src: PromptRegular });
  Font.register({ family: "Browallia", src: Browallia });
};

const getHorizonView = (label, data) => {
  return (
    <View style={styles.horizonView}>
      <Text style={styles.textLabel}>{label}:</Text>
      <Text style={styles.textSmall}>{data}</Text>
    </View>
  );
};

export const GetBillHeader = async ({ data }) => {
  const { Branch, DocuType } = data?.DocuBranch?.BranchDocu;
  const { Staff } = data?.CreateBy;

  return (
    <View>
      <View style={styles.pageHeader}>
        <View>
          <View style={styles.companyBox}>
            <View style={styles.headerLogo}>
              <Image
                style={styles.logo}
                src={"/logos/logo_comp_" + Branch.Company?.CompId + ".png"}
              />
            </View>
            <View>
              <Text style={styles.textSmall}>{Branch.Company?.CompNameTh}</Text>
              <Text style={styles.textVerySmall}>
                {Branch.Company?.CompAddrTh}
              </Text>
              <Text style={styles.textVerySmall}>
                {Branch.Company?.CompAddrTh2}
              </Text>
              <Text style={styles.textVerySmall}>
                โทร.{Branch.Company?.Phone} เลขประจำตัวผู้เสียภาษี{" "}
                {Branch.Company?.Taxid}
              </Text>
            </View>
          </View>

          <View style={{ height: "5px" }} />
          <Text style={styles.textSmall}>{Branch?.BrchName}</Text>
          <Text style={{ ...styles.textVerySmall, color: "#000000" }}>
            {Branch?.BrchAddr1 +
              " " +
              Branch?.BrchAddr2 +
              " " +
              // Branch?.BrchPhone ??
              ""}
          </Text>
        </View>

        <View>
          <View style={styles.docuNameBox}>
            <Text style={styles.textVeryLarge}>{DocuType?.DocuTypeText} </Text>
          </View>
          {getHorizonView("เลขทีเอกสาร", data?.DocuNo)}
          {getHorizonView("วันที่เอกสาร", GetThaiFormatDate(data?.DocuDate))}
          {getHorizonView("เจ้าหน้าที่", Staff?.FullName)}
        </View>
      </View>
    </View>
  );
};

export const GetPayDFHeader = async (props) => {
  const { data } = props;
  const { Branch, DocuType } = data?.DocuBranch?.BranchDocu;
  const { Staff } = data?.CreateBy;
};

export const GetBillCustomer = async ({ data }) => {
  const { Study } = data;
  // console.log(Study);
  return (
    <View>
      <View style={styles.horizonView}>
        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ออกให้กับ:</Text>
            <Text style={styles.textValue}>{data?.BillTo}</Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ที่อยู่:</Text>
            <Text style={styles.textValue}>{data?.BillAddr1}</Text>
          </View>

          <View style={styles.horizonView}>
            <Text style={styles.textValue}>{data?.BillAddr2}</Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>โทรศัพท์:</Text>
            <Text style={styles.textValue}>{data?.BillPhone}</Text>
          </View>
        </View>

        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ชื่อคนไข้: </Text>
            <Text style={styles.textValue}>{Study?.PatientsName} </Text>
          </View>

          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>เลขที่บัตร: </Text>
            <Text style={styles.textValue}>{Study?.PatientIdCard} </Text>
          </View>

          <View style={{ ...styles.horizonView, justifyContent: "flex-start" }}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>อายุ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientAge(Study?.PatientsAge)}
              </Text>
            </View>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>เพศ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientSex(Study?.PatientsSex)}
              </Text>
            </View>
          </View>
          <View style={styles.horizonView}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>สิทธิการรักษา: </Text>
              <Text style={styles.textValue}>
                {Study?.BranchPatientRight?.BrchRightName}
              </Text>
            </View>
          </View>
        </View>
      </View>

      {/* <View style={styles.drawLine}></View> */}
      {/*  */}
      <View style={styles.horizonView}>
        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>รพ/คลินิก: </Text>
          <Text style={styles.textValue}>
            {Study?.CustomerSender?.CustName}
          </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>HN: </Text>
          <Text style={styles.textValue}>{Study?.PatientId} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>วอร์ด: </Text>
          <Text style={styles.textValue}>{Study?.BranchWard?.WardName} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>แพทย์ส่ง: </Text>
          <Text style={styles.textValue}>
            {Study?.Physician &&
              Study?.Physician?.FullFirstName +
                " " +
                Study?.Physician?.LastName}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const GetReceiptCustomer = async ({ data }) => {
  console.log(data);
  const { Study } = data?.Invoice;
  console.log(Study);
  const getView = (label, data) => {
    return (
      <View style={styles.horizonView}>
        <Text style={styles.textLabel}>{label}:</Text>
        <Text style={styles.textValue}>{data}</Text>
      </View>
    );
  };
  return (
    <View>
      <View style={styles.horizonView}>
        <View style={{ ...styles.customerDetailBox, marginRight: "3px" }}>
          {getView("ออกให้กับ", data?.BillTo)}
          {getView("ที่อยู่", data?.BillAddr2)}
          {getView("โทรศัพท์", data?.BillPhone)}
        </View>

        <View style={{ ...styles.customerDetailBox, marginLeft: "3px" }}>
          {getView("ชื่อคนไข้", Study?.PatientsName)}
          {getView("เลขที่บัตร", Study?.PatientIdCard)}

          <View
            style={
              {
                // ...styles.horizonView,
                // justifyContent: "flex-start",
                // flex: "1",
                // border: "1px solid black",
              }
            }
          >
            {getView("อายุ", GetPatientAge(Study?.PatientsAge))}
            {getView("เพศ", GetPatientSex(Study?.PatientsSex))}
          </View>

          {/* {getView("สิทธิการรักษา", Study?.BranchPatientRight?.BrchRightName)} */}
        </View>
      </View>

      {/* <View style={styles.drawLine}></View> */}
      {/*  */}
      <View style={styles.horizonView}>
        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>รพ/คลินิก: </Text>
          <Text style={styles.textValue}>
            {Study?.CustomerSender?.CustName}
          </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>HN: </Text>
          <Text style={styles.textValue}>{Study?.PatientId} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>วอร์ด: </Text>
          <Text style={styles.textValue}>{Study?.BranchWard?.WardName} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>แพทย์ส่ง: </Text>
          <Text style={styles.textValue}>
            {Study?.Physician &&
              Study?.Physician?.FullFirstName +
                " " +
                Study?.Physician?.LastName}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const GetBillItems = async ({ data }) => {
  const { StudyItems } = data?.Study ?? data?.Invoice?.Study;

  return (
    <View style={{ flex: "1" }}>
      <View style={styles.itemRow}>
        <Text style={{ ...styles.itemStep, ...styles.itemHeader }}>
          {"ที่"}
        </Text>
        <Text style={{ ...styles.itemCode, ...styles.itemHeader }}>
          {"รหัสสินค้า"}
        </Text>
        <Text style={{ ...styles.itemName, ...styles.itemHeader }}>
          {"ชื่อสินค้า/บริการ"}
        </Text>
        <Text style={{ ...styles.itemQty, ...styles.itemHeader }}>
          {"จำนวน"}
        </Text>
        <Text style={{ ...styles.itemPrice, ...styles.itemHeader }}>
          {"ราคา/หน่วย"}
        </Text>
        <Text style={{ ...styles.itemTotal, ...styles.itemHeader }}>
          {"รวม"}
        </Text>
      </View>
      <Line x1={0} x2={100} y1={50} y2={50} />
      {StudyItems?.map((item, index) => {
        return (
          <View style={styles.itemRow}>
            <Text style={styles.itemStep}>{Number(index) + 1 + "."}</Text>
            <Text style={styles.itemCode}>{item?.ItemCode ?? ""}</Text>
            <Text style={styles.itemName}>{item?.ItemName ?? ""}</Text>
            <Text style={styles.itemQty}>
              {getDecimalString(item?.Qty ?? 0, 2)}
            </Text>
            <Text style={styles.itemPrice}>
              {getDecimalString(item?.Price ?? 0, 2)}
            </Text>
            <Text style={styles.itemTotal}>
              {getDecimalString(item?.Total ?? 0, 2)}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

export const GetInvoiceFooter = async ({ data }) => {
  const { StudyItems } = data?.Study ?? data?.Invoice?.Study;
  const { Staff } = data?.CreateBy;
  const objPrice = (text, item) => {
    return (
      <View style={styles.horizonView}>
        <Text style={styles.textLabel}>{text} </Text>
        <Text style={styles.itemPrice}>{item} </Text>
      </View>
    );
  };

  return (
    <View>
      <View style={styles.pageHeader}>
        {/* Left Panel */}
        <View style={{ flex: "2", marginRight: "2px" }}>
          <View style={{ ...styles.horizonView, display: "flex" }}>
            <Text style={styles.textLabel}>รวม</Text>
            <Text
              style={{
                ...styles.textValue,
                paddingHorizontal: "10px",
                flex: "1",
              }}
            >
              {StudyItems?.length ?? 0} {"  รายการ"}
            </Text>
          </View>

          <Text style={styles.textLabel}>รวมเป็นเงินทังสิ้น(ตัวอักษร):</Text>
          <View style={styles.thaiBaht}>
            <Text style={styles.textLabel}>
              {GetThaiBahtString(getCommalessNumber(data?.NetTotal))}
            </Text>
          </View>
        </View>
        {/* Right Panel */}
        <View style={{ flex: "1", marginLeft: "2px" }}>
          {objPrice("ราคารวม", getDecimalString(data?.Amount, 2))}
          {objPrice("ส่วนลด", getDecimalString(data?.Discount, 2))}
          {objPrice("ยอดก่อนหักภาษี", getDecimalString(data?.Total, 2))}
          {objPrice("อัตราภาษีมูลค่าเพิ่ม", getDecimalString(data?.VatRate, 2))}
          {objPrice(
            "ยอดรวมภาษีมูลค่าเพิ่ม",
            getDecimalString(data?.VatTotal, 2)
          )}
          {objPrice("ยอดสุทธิ", getDecimalString(data?.NetTotal, 2))}

          <View style={styles.drawLine} />
          {objPrice("เครดิต(วัน)", getDecimalString(data?.CreditDays, 0))}
          {objPrice("นัดชำระ", GetThaiFormatDate(data?.DocuDueDate))}
        </View>
      </View>
      {/* ข้อความรับเงินแล้ว */}
      <View style={{ ...styles.horizonView }}>
        <View
          style={{
            ...styles.verticalCenter,
            border: "0.7px solid #444444",
            flex: "1",
            marginRight: "2px",
            borderRadius: "5px",
          }}
        >
          {GetCenterTextView("  ")}
          {GetCenterTextView(
            "ลงชื่อ ........................................... ผู้ตรวจสอบ"
          )}
          {GetCenterTextView(
            "(...........................................)            "
          )}
          {GetCenterTextView(
            "............/................./...........             "
          )}
        </View>
        <View
          style={{
            ...styles.verticalCenter,
            border: "0.7px solid #444444",
            marginLeft: "2px",
            flex: "1",
            borderRadius: "5px",
          }}
        >
          {GetCenterTextView("  ")}
          {GetCenterTextView(
            "ลงชื่อ      ...........................................เจ้าหน้าที่"
          )}
          {GetCenterTextView("( " + Staff?.FullName + " )")}
          {GetCenterTextView(GetThaiFormatDate(new Date()))}
        </View>
      </View>
      <View>
        {GetCenterTextView("  ")}
        {GetCenterTextView("  ")}
      </View>
    </View>
  );
};

export const GetReceiptFooter = async ({ data }) => {
  const { StudyItems } = data?.Study ?? data?.Invoice?.Study;
  const { Branch, DocuType } = data?.DocuBranch?.BranchDocu;
  const { RecieptPayments } = data;

  const objPrice = (text, item) => {
    return (
      <View style={styles.horizonView}>
        <Text style={styles.textLabel}>{text} </Text>
        <Text style={styles.itemPrice}>{item} </Text>
      </View>
    );
  };

  return (
    <View>
      <View style={styles.drawLine} />
      <View style={styles.pageHeader}>
        {/* Left Panel */}
        <View style={{ flex: "2", marginRight: "2px" }}>
          <View style={{ ...styles.horizonView, display: "flex" }}>
            <Text style={styles.textLabel}>รวม</Text>
            <Text
              style={{
                ...styles.textValue,
                paddingHorizontal: "10px",
                flex: "1",
              }}
            >
              {StudyItems?.length ?? 0} {"  รายการ"}
            </Text>
          </View>

          <Text style={styles.textLabel}>รวมเป็นเงินทังสิ้น(ตัวอักษร):</Text>
          <View style={styles.thaiBaht}>
            <Text style={styles.textLabel}>
              {GetThaiBahtString(getCommalessNumber(data?.NetTotal))}
            </Text>
          </View>

          <View
            style={{ ...styles.horizonView, padding: "0px", margin: "0px" }}
          >
            <View
              style={{
                ...styles.verticalCenter,
                justifyContent: "flex-start",
                alignItems: "flex-start",
                padding: "5px",
              }}
            >
              {GetCenterTextView("ชำระด้วย:")}
              {RecieptPayments?.map((row, i) => {
                if (row?.PayMethod?.PayMethodId < 2) {
                  return GetCenterTextView(
                    "- " + row?.PayMethod?.PayMethodName
                  );
                } else {
                  return GetCenterTextView(
                    "- " +
                      row?.PayMethod?.PayMethodName +
                      " " +
                      row?.ChqBank?.BankShort +
                      " เลขที่ " +
                      row?.ChqNo +
                      "  ลงวันที่(" +
                      GetThaiFormatDate(row?.ChqDate ?? "") +
                      ")"
                  );
                }
              })}
            </View>
          </View>
        </View>
        {/* Right Panel */}
        <View style={{ flex: "1", marginLeft: "2px" }}>
          {objPrice("ราคารวม", getDecimalString(data?.Amount, 2))}
          {objPrice("ส่วนลด", getDecimalString(data?.Discount, 2))}
          {objPrice("ยอดก่อนหักภาษี", getDecimalString(data?.Total, 2))}
          {objPrice(
            "อัตราภาษีมูลค่าเพิ่ม",
            getDecimalString(Number(data?.VatRate) * 100, 0) + "%"
          )}
          {objPrice(
            "ยอดรวมภาษีมูลค่าเพิ่ม",
            getDecimalString(data?.VatTotal, 2)
          )}
          {objPrice("ยอดสุทธิ", getDecimalString(data?.NetTotal, 2))}

          <View style={styles.drawLine} />
          {objPrice(
            "อัตราภาษีหัก ณ ที่จ่าย",
            // getDecimalString(data?.HoldingTaxRate, 2)
            getDecimalString(Number(data?.HoldingTaxRate) * 100, 0) + "%"
          )}
          {objPrice(
            "ยอดเงินหัก ณ ที่จ่าย",
            getDecimalString(data?.HoldingTaxAmount, 2)
          )}
        </View>
      </View>

      {/* ข้อความรับเงินแล้ว */}
      <View style={{ ...styles.horizonView }}>
        <View
          style={{
            ...styles.verticalCenter,
            border: "0.7px solid #444444",
            flex: "1",
            marginRight: "2px",
            borderRadius: "5px",
          }}
        >
          {GetCenterTextView("ได้รับเงินแล้ว ด้วยความขอบคุณ")}
          {GetCenterTextView("ในนาม " + Branch.Company?.CompNameTh)}
          {GetCenterTextView("  ")}
          {GetCenterTextView(
            "ลงชื่อ ...........................................ผู้รับเงิน"
          )}
        </View>
        <View
          style={{
            ...styles.verticalCenter,
            border: "0.7px solid #444444",
            marginLeft: "2px",
            flex: "1",
            borderRadius: "5px",
          }}
        >
          {GetVerySmallTextView(
            "ได้รับสินค้าตามรายการข้างต้นถูกต้องและเรียบร้อย"
          )}
          {GetVerySmallTextView("จึงลงลายมือชื่อไว้เป็นหลักฐาน")}
          {GetVerySmallTextView("  ")}
          {GetVerySmallTextView(
            "ลงชื่อ ...........................................ผู้ชำระเงิน"
          )}
        </View>
      </View>
      <View>
        {GetVerySmallTextView("*หมายเหตุ")}
        {GetVerySmallTextView(
          "โปรดจ่ายเช็คขีดคร่อมในาม" + Branch.Company?.CompNameTh
        )}
        {GetVerySmallTextView(
          "ใบเสร็จรับเงินจะสมบูรณ์ได้ก็ต่อเมื่อผู้ได้ลงนามรับเงินและลงวันที่แล้ว"
        )}
        {GetVerySmallTextView(
          "หากชำระด้วยเช็ค ใบเสร็จรับเงินจะสมบูรณ์ต่อเมื่อบริษัทได้เรียกเก็บเงินตามเช็คเรียบร้อยแล้วเท่านั้น"
        )}
      </View>
      <View style={styles.verticalSpacing} />
    </View>
  );
};

export const BuildInvoicePDF = async ([pdf, setPdf, data]) => {
  RegisterFont();
  let docHeader = await GetBillHeader({ data });
  let customer = await GetBillCustomer({ data });
  let items = await GetBillItems({ data });
  let footer = await GetInvoiceFooter({ data });
  setPdf(
    <InvoiceBill
      {...{
        docHeader: docHeader,
        customer: customer,
        items: items,
        footer: footer,
      }}
    />
  );
};

export const BuildReceiptPDF = async ([pdf, setPdf, data, study]) => {
  RegisterFont();

  let docHeader = await GetBillHeader({ data });
  let customer = await GetReceiptCustomer({ data });
  let items = await GetBillItems({ data });
  let footer = await GetReceiptFooter({ data });
  setPdf(
    <InvoiceBill
      {...{
        docHeader: docHeader,
        customer: customer,
        items: items,
        footer: footer,
      }}
    />
  );
};

export default function InvoiceBill(props) {
  const { size } = props;
  RegisterFont();

  const { docHeader, customer, items, footer } = props;

  return (
    <Document style={styles.document}>
      <Page size={size ?? "A4"} style={styles.page}>
        {docHeader}
        {/* <View style={styles.drawLine} /> */}
        {customer}
        <View style={styles.drawLine} />
        <View style={styles.verticalSpacing} />
        {items}
        <View style={styles.drawLine} />
        {footer}
      </Page>
    </Document>
  );
}

export function BuildDocument(props) {
  const { size, pageStyles } = props;
  RegisterFont();

  const { docHeader, customer, items, footer, footer2 } = props;

  return (
    <Document style={styles.document}>
      <Page size={size ?? "A4"} style={{ ...styles.page, ...pageStyles }}>
        {docHeader}
        {/* <View style={styles.drawLine} /> */}
        {customer}
        <View style={styles.drawLine} />
        <View style={styles.verticalSpacing} />
        {items}
        <View style={styles.drawLine} />
        {footer}
        {footer2}
      </Page>
    </Document>
  );
}
